import React, { useEffect } from "react";
import "./styles.scss";
import CloseButton from "../../organisms/modals/CloseButton";

const SideOverlay = ({
  side = "left",
  isOpen,
  onClose,
  title = "Title",
  children,
  styles,
  width = "400px",
}) => {
  const sideStyles = {
    left: { left: isOpen ? "0" : `-${width}`, width },
    right: { right: isOpen ? "0" : `-${width}`, width },
    top: { top: isOpen ? "0" : `-${width}` },
    bottom: { bottom: isOpen ? "0" : `-${width}` },
  };

  // Lock background scroll when drawer is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto"; // Cleanup when component unmounts or closes
    };
  }, [isOpen]);

  return (
    <>
      {isOpen && <div className="backdrop"></div>}
      <div className={`drawer drawer-${side}`} style={sideStyles[side]}>
        <div className="d-flex justify-content-between mb-2 mt-2">
          <div className="h1-j">{title}</div>
          <CloseButton
            onClose={onClose}
            size={20}
            classes={"d-flex justify-content-end"}
          />
        </div>

        <div className="content">{children}</div>
      </div>
    </>
  );
};

export default SideOverlay;
